import "./Calculette.css";

const Calculette = ({ children }) => {
    return <div className="calculatrice">{children}</div>;
};

export default Calculette;